import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Footer() {
	const navigate = useNavigate();
	const { user } = useContext(AuthContext);
	const externalpageNavigate = (path) => {
		window.location.href = path;
	};

	const pageNavigate = (path) => {
		if (user) {
			navigate(`/${path}`);
		} else {
			toast.info("Login to access the content");
			navigate(`/auth`);
		}
	};

	const navigateToTab = (tabName) => {
		navigate(`/allterms?tab=${tabName}`);
	};

	return (
		<footer className="w-full flex flex-col">
			<div className="w-full lg:px-20 px-5 py-10 flex flex-col lg:flex-row mb-10">
				<div className="lg:w-1/3">
					<div className="text-2xl font-semibold mb-10">
						Academy-<span className="text-gray-500">nest</span>
					</div>
				</div>
				<div className="lg:w-2/3 text-sm grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
					<div className="flex flex-col space-y-3">
						<div className="font-semibold">Company</div>
						<div className="flex flex-col space-y-2 text-gray-600 items-start ml-1">
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/about"
									)
								}
								className="hover:underline"
							>
								About
							</button>
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/Team"
									)
								}
								className="hover:underline"
							>
								Team
							</button>
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/Careers"
									)
								}
								className="hover:underline"
							>
								Careers
							</button>
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/Blog"
									)
								}
								className="hover:underline"
							>
								Blog
							</button>
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/Press"
									)
								}
								className="hover:underline"
							>
								Press
							</button>
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/Contact"
									)
								}
								className="hover:underline"
							>
								Contact
							</button>
						</div>
					</div>

					<div className="flex flex-col space-y-3">
						<div className="font-semibold">Categories</div>
						<div className="flex flex-col space-y-2 text-gray-600 items-start ml-1">
							<button
								onClick={() => pageNavigate("enroll")}
								className="hover:underline"
							>
								Technology
							</button>
							<button
								onClick={() => pageNavigate("enroll")}
								className="hover:underline"
							>
								Language
							</button>
							<button
								onClick={() => pageNavigate("enroll")}
								className="hover:underline"
							>
								Home Tutoring
							</button>
							<button
								onClick={() => pageNavigate("enroll")}
								className="hover:underline"
							>
								Arabic Books
							</button>
						</div>
					</div>

					<div className="flex flex-col space-y-3">
						<div className="font-semibold">Support</div>
						<div className="flex flex-col space-y-2 text-gray-600 items-start ml-1">
							<button className="hover:underline">
								Help Center
							</button>
							<button className="hover:underline">
								Trust & Safety
							</button>
							<button className="hover:underline">
								Buying on E-Learning
							</button>
						</div>
					</div>

					<div className="flex flex-col space-y-3">
						<div className="font-semibold">Blog</div>
						<div className="flex flex-col space-y-2 text-gray-600 items-start">
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/Blog"
									)
								}
								className="hover:underline"
							>
								Latest
							</button>
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/Blog"
									)
								}
								className="hover:underline"
							>
								Most Popular
							</button>
							<button
								onClick={() =>
									externalpageNavigate(
										"https://ecybernet.com/Blog"
									)
								}
								className="hover:underline"
							>
								Most Read
							</button>
						</div>
					</div>

					<div className="flex flex-col space-y-3">
						<div className="font-semibold">Legal & Compliance</div>
						<div className="flex flex-col space-y-2 text-gray-600 items-start ml-1">
							<button
								className="hover:underline"
								onClick={() => navigateToTab("PrivacyPolicy")}
							>
								Privacy Policy
							</button>
							<button
								className="hover:underline"
								onClick={() => navigateToTab("TermsOfUse")}
							>
								Terms of Use
							</button>
							<button
								className="hover:underline"
								onClick={() => navigateToTab("CookiePolicy")}
							>
								Cookie Policy
							</button>
							<button
								className="hover:underline"
								onClick={() =>
									navigateToTab("TermsAndConditions")
								}
							>
								Terms & Conditions
							</button>
						</div>
					</div>

					<div className="flex flex-col space-y-3">
						<div className="font-semibold">Social Media</div>
						<div className="flex flex-col space-y-2 text-gray-600 items-start ml-1">
							<button className="hover:underline">
								Facebook
							</button>
							<button className="hover:underline">Twitter</button>
							<button className="hover:underline">
								Instagram
							</button>
							<button className="hover:underline">
								Linkedin
							</button>
						</div>
					</div>
				</div>
			</div>

			<div className="w-full py-4 border-t border-gray-300">
				<div className="w-full flex justify-center md:justify-start md:px-20 items-center text-xs text-gray-700">
					<div>
						&copy; {new Date().getFullYear()} E-CyberNest. All
						rights reserved.
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
